export const toCreateTaxonomyNodeHierarchy = (
    nNode: Models.ContentStoreApi.V3.TaxonomyNode,
    index: number,
): Models.ContentStoreApi.V3.UpsertTaxonomyNodeHierarchy => ({
    category: { href: nNode._embedded.category.href },
    children: nNode.children?.map((c, i) => toCreateTaxonomyNodeHierarchy(c, i)) ?? [],
    sortOrder: index,
});
